import React, { Component } from 'react'
import { connect } from 'react-redux'
import withTranslationWrapper from '../../HOC/HocTranslate'
import Layout from './../../wrapper'
import { ShowDeviceModels } from '../../Components/DeviceModels/'
import { logInUserInfo } from '../../Actions/Users'
import { notifyError } from '../../Utils/CustomNotifcations'
import withRoutes from '../../HOC/HocRoutes'
import { apiFetch } from '../../Utils/apiFetch'

class DeviceModelsPage extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userInfo: {}
    }
  }

  render () {
    if (this.props.logInUser) {
      return (
        <Layout
          {...this.props}
          noSidebar
        >
          <ShowDeviceModels {...this.props} />
        </Layout>
      )
    } else {
      apiFetch('/api/session?app=2bd5bd10345cd1555b14c221ec6e8647c46ee21e8ee45312', {
        headers: { Accept: 'application/json; odata=verbose' }
      }).then(response => {
        if (response.ok) {
          response.json().then(res => {
            if (res.status === 'success') {
              const userInfo = res.data
              this.props.setActiveLanguage(userInfo?.attributes?.lang || 'en')
              this.props.dispatch(logInUserInfo(userInfo))
            } else if (res?.statusCode === '440') {
              window.location.replace('/login')
            } else if (res.statusCode) {
              const err = res?.message.split(':')
              err[1] = err[1].replace(')', '')
              this.props.dispatch(notifyError(err[1]))
              this.props.navigate('/logout')
            }
          })
        } else {
          this.props.navigate('/logout')
          throw response
        }
      }).catch(() => {
        this.props.dispatch(notifyError('somethingWentWrong'))
      })
      return null
    }
  }
}

const mapStateToProps = state => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers
})

export default connect(mapStateToProps)(withRoutes(withTranslationWrapper(DeviceModelsPage)))
